<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelLocalidade"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="name"
    track-by="value"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }"
      ><span class="badge badge-primary mr-1"
        ><span class="text-truncate mr-1 mb-1">{{ option.name }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeLocalidade(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-input-tag/vue-input-tag.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
import InputTag from 'vue-input-tag';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'empresas',
    'filtroSiteParceiro',
    'confirmDelete'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false,
      initialItems: []
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'localidadesSelecionadas', null);
        return;
      }
      this.$emit('selectChange', 'localidadesSelecionadas', e);
    },
    labelLocalidade({ name }) {
      return `${name}`;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'localidadesSelecionadas', value);
      } else {
        if (value) {
          if (value.value) {
            this.selected = this.options.find((option) => option.value === value.value);
          } else {
            this.selected = this.options.find((option) => option.value === value);
          }
        } else {
          this.selected = this.options.find((option) => option.value === null);
        }
        this.$emit('input', this.selected);
      }
    },
    clearAll() {
      this.value = [];
    },
    setOptions(empresas) {
      let arrayEmp = this.onlyValueArray(empresas);
      arrayEmp.length === 0 || arrayEmp == undefined
        ? arrayEmp.push(this.$store.state.user.info.id_empresa)
        : null;

      let filtro = `id_empresa in(${arrayEmp.toString()}) and excluido=false `;

      if (this.filtroSiteParceiro == true) {
        filtro +=
          'and business_logic.localidade.id not in (select distinct ((json_array_elements(id_localidades)::text)::integer) from business_logic.localidade_web) ';
      }

      if (this.alreadyAdded.length > 0) {
        filtro += `union select id, numero, nome from business_logic.localidade where id in (${this.alreadyAdded.toString()})`;
      }

      this.isLoading = true;
      this.$atenaList
        .getLocalidades({
          columns: 'id, numero, nome',
          filter: filtro,
          order: 'numero'
        })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ name: this.$i18n.t(this.emptyLabel), value: null }];
          }
          res.data.forEach((e) => {
            this.options.push({
              name: `${e.numero} - ${e.nome}`,
              value: e.id
            });
          });
          this.nameField.length === 0
            ? this.showOptionsSel(this.alreadyAdded)
            : this.showOptionsSel(this.onlyValueArray(this.nameField));

          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    showOptionsSel(optionsSel) {
      if (optionsSel.length >= 0 || optionsSel != undefined) {
        this.initialItems = [];
        optionsSel.forEach((id) => {
          const item = this.options.find((e) => {
            return e.value === id;
          });
          if (item) {
            this.initialItems.push(item);
          }
        });
        this.setValue(this.initialItems);
      }
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.value === element.value);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.value === option.value);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.value != el.value);
        }
      });
      this.setValue(valueCp);
      this.options = [option, ...this.options];
    },
    removeLocalidade(option) {
      if (this.confirmDelete) {
        const mensagem = this.$createElement('span', [
          this.$i18n.t('Localidade') + ': ',
          this.$createElement('strong', option.name),
          this.$createElement('br'),
          this.$createElement('br'),
          this.$i18n.t('Confima esta ação?')
        ]);
        this.$bvModal
          .msgBoxConfirm(mensagem, {
            title: this.$i18n.t('Excluir Localidade'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: this.$i18n.t('Confirmar'),
            cancelTitle: this.$i18n.t('Fechar'),
            footerClass: 'p-2',
            hideHeaderClose: false
          })
          .then((value) => {
            if (value) {
              this.removeOption(option);
            }
          })
          .catch((err) => console.log(err));
      } else {
        this.removeOption(option);
      }
    },
    onlyValueArray(array) {
      let arrayValue = [];
      array.forEach((e) => {
        arrayValue.push(e.value);
      });
      return arrayValue;
    }
  },
  created() {
    this.setOptions(this.empresas);
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    alreadyAdded: function (value) {
      this.showOptionsSel(value);
    },
    empresas(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
